/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { loginResponseV4ApiResponseObjectV4Schema } from './loginResponseV4ApiResponseObjectV4Schema'

export const authSupportStopStatus200Schema = loginResponseV4ApiResponseObjectV4Schema.describe(
  'Typed variant of EP.Models.ViewModels.ApiResponseObjectV4, used in `[ProducesResponseType]` so Swagger renders\r\nthe real `result` schema instead of the bare `object` (which the UI shows as `"string"`).\r\nWire shape is identical to the untyped envelope — this only carries the type for the schema generator.'
)

export const authSupportStopResponseSchema = authSupportStopStatus200Schema
